import React from 'react';
import Icon from '../icon/icon';
import './Experience.scss';


class Experience extends React.Component {
    render() {
        let image;
        if (this.props.logo.indexOf('.') > -1) {
            image = <img src={"/assets/img/icons/" + this.props.logo} alt={this.props.logo} />
        } else {
            image = <Icon icon={this.props.logo} size={48} color={"#fff"} />
        }
        return (
            <div className="experience">
                {image}
                <div className="details">
                    <h3>{this.props.jobTitle}</h3>
                    <h4>{this.props.company}</h4>
                    <h4>{this.props.fromDate} - {this.props.toDate || 'present'}</h4>
                    <h5>{this.props.location}</h5>
                    <span>Technologies: {this.props.technologies}</span>
                    <span className="moreDetails">More details</span>
                </div>
            </div>
        );
    }
}

export default Experience;